import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { isProd } from 'constants/environment';
import { getGtmGatewaySourceUrl } from 'constants/gtm';
import { useCookieConsentValue } from 'hooks/useCookieConsentValue';
import { initializeGtm } from 'utils/gtm/initializeGtm';

const tmArgsDev = {
  auth: 'EgwuMOzpTK5i34BvOtQG9w',
  preview: 'env-149',
};

const cbAtTmArgsDev = {
  auth: 'aXk6vUANquVykx29KHAMQw',
  preview: 'env-3',
};

const smartcarbAtTmArgsDev = {
  auth: 'B6HMluM-UWWxtA3JtAmgAA',
  preview: 'env-3',
};

const frgTmArgsDev = {
  auth: 'YVLwQV9APFGNJu31ayyHeQ',
  preview: 'env-3',
};

const buildGtmConfig = (tenant: string) => {
  switch (tenant) {
    case 'carbonify':
      return {
        gtmId: 'GTM-NNGL797',
        tmArgs: isProd ? {} : tmArgsDev,
      };
    case 'carbonifyat':
      return {
        gtmId: 'GTM-K254RC93',
        tmArgs: isProd ? {} : cbAtTmArgsDev,
      };
    case 'smartcarb':
      return {
        gtmId: 'GTM-PDX2FSSF',
        tmArgs: isProd ? {} : smartcarbAtTmArgsDev,
      };
    case 'fairnergy':
      return {
        gtmId: 'GTM-KH25FVJX',
        tmArgs: isProd ? {} : frgTmArgsDev,
      };
  }
  return undefined;
};

const GoogleTagManager = ({ tenant }: { tenant: string }) => {
  const cookieConsentValue = useCookieConsentValue(tenant);

  useEffect(() => {
    const config = buildGtmConfig(tenant);
    if (!config) {
      return;
    }
    const { gtmId, tmArgs } = config;
    const sourceUrl = getGtmGatewaySourceUrl(tenant);
    const dataLayer = {
      cbconsent: cookieConsentValue,
    };

    if (sourceUrl) {
      initializeGtm({
        gtmId,
        sourceUrl,
        ...tmArgs,
        dataLayer,
      });
      return;
    }

    TagManager.initialize({
      gtmId,
      ...tmArgs,
      dataLayer,
    });
  }, [cookieConsentValue, tenant]);

  return null;
};

export default GoogleTagManager;
